import { useState } from "react";
import { useToasts } from "react-toast-notifications";
import moment from "moment";
import SubscribersTable from "./subscribers-table";

import "../../styles.css";
import "./style.scss";
import SubscribersActions from "./subscribers-actions";

const SubscriberPaymentHistory = () => {
  const perPage = 50;
  const numDates = 12;

  const { addToast } = useToasts();

  const [login, setLogin] = useState("");
  const [history, setHistory] = useState("monthly");
  const [page, setPage] = useState(1);
  const [subscribers, setSubscribers] = useState([]);
  const [columns, setColumns] = useState([]);
  const [pageItems, setPageItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [orderBy, setOrderBy] = useState("ASC");
  const [busy, setBusy] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if(!login)
      return addToast('Please enter a subscriber first.', { appearance: 'info', autoDismiss: true });
      
    getHistory();
    setBusy(true);
    generateColumns(history);
  };

  const getHistory = () => {
    axios.get("/api/administration/subscribers/history", {
      params: {
        page: page,
        per_page: perPage,
        login: login,
        order_by: orderBy,
        history: history,
      },
    })
    .then((response) => {
      const data = response.data;
      setSubscribers(data.data);
      setTotal(Math.ceil(data.total/perPage))
      if(data.total == 0)
        addToast("Currently there's 0 total history from searched data.", { appearance: 'info', autoDismiss: true });
    })
    .catch((error) => {})
    .finally(() => {
      setBusy(false);
    });
  };

  const generateColumns = (history = null) => {
    let tmpCol = ["Username"];
    let dateFormatted = null;

    for (let i = 0; i < numDates; i++) {
      const now = dateFormatted ? moment(dateFormatted) : moment();
      tmpCol.push(now.subtract(i, history === "monthly" ? "months" : "years").format(history === "monthly" ? "MMM YYYY" : "YYYY"));
    }

    setColumns(tmpCol);
  };

  return (
    <div className="subscriber-payment-history">
      <h3 className="mb-4">Subscriber Payment History</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-row align-items-center">
          <SubscribersActions
            busy={busy}
            login={login}
            setLogin={setLogin}
            handleSubmit={handleSubmit}
            setHistory={setHistory}
          />

          {subscribers.length > 0 && 
            <SubscribersTable
              subscribers={subscribers}
              columns={columns}
              pageItems={pageItems}
              orderBy={orderBy}
              page={page}
              total={total}
              setPage={setPage}
              setOrderBy={setOrderBy}
            />
          }
        </div>
      </form>
    </div>
  );
};

export default SubscriberPaymentHistory;
